import "./WhatWeDo.css";

const WhatWeDo = ({ leftColumn, rightColumn }) => {
  return (
    <div className="column-banner">
      <div className="column-banner-item  column-banner-left">
        <div className="column-banner-content">{leftColumn}</div>
      </div>
      <div className="column-banner-item  column-banner-right">
        <div className="column-banner-content">{rightColumn}</div>
      </div>
    </div>
  );
};

export default WhatWeDo;
